function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48c000"
    },
    fillRule: "evenodd",
    d: "M15 0C6.716 0 .001 6.714.001 14.998.001 23.283 6.716 30 15 30s15.001-6.717 15.001-15.002C30.001 6.714 23.284 0 15 0zm-1.871 19.412l-4.305-4.007 1.419-1.317 2.886 2.69 6.629-6.19 1.419 1.317-8.048 7.507z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConfirm);
export default __webpack_public_path__ + "static/media/ico-confirm.07e4844601e48baddcb02dde731d66e7.svg";
export { ForwardRef as ReactComponent };